import {navigation} from './partials/navigation.js';

navigation();